import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function Title({ children }) {
  return (
    <Typography
      variant="h5"
      component="h2"
      noWrap
      color="primary"
      gutterBottom
      sx={{
        fontWeight: 500,
        mt: 1,
        lineHeight: 1.25,
        fontSize: {
          xs: '0.75rem',
          sm: '1.0rem',
        },
      }}
    >
      {children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
